import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Icon from '../Icon'
import { CopyToClipboard as ReactCopyToClipboard } from 'react-copy-to-clipboard/lib/Component'

class CopyToClipboard extends PureComponent {
  state = {
    copied: false,
  }

  render () {
    return (
      <div style={{ display: 'inline-block' }}>
        <ReactCopyToClipboard text={this.props.text}
                              onCopy={() => this.setState({ copied: true })}>
          <div style={{ display: 'inline-block', marginLeft: '5px' }}
               onMouseLeave={() => this.setState({ copied: false })}>
            <Icon
              size={this.props.size}
              tooltip={this.state.copied ? 'Copied' : 'Copy'} type={'fa'} faClassName={'fa-copy'}
              style={{ display: 'inline' }}/>
          </div>
        </ReactCopyToClipboard>
      </div>
    )
  }
}

CopyToClipboard.defaultProps = {
  size: 'small'
}

CopyToClipboard.propTypes = {
  text: PropTypes.string.isRequired,
  size: PropTypes.string
}
export default CopyToClipboard

